import React from "react"
import { useAppSelector, useAppDispatch } from "@/app/hooks"
import {
  selectIsAuthenticated,
  setLoginSheetOpen,
} from "@/features/auth/authSlice"

type PrivateRouteProps = {
  children: React.ReactElement
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const dispatch = useAppDispatch()

  React.useEffect(() => {
    if (!isAuthenticated) {
      dispatch(setLoginSheetOpen(true))
    }
  }, [isAuthenticated, dispatch])

  if (!isAuthenticated) {
    return null // 비로그인 시, 로그인 시트가 열리는 동안 아무것도 표시하지 않습니다.
  }

  return children
}

export default PrivateRoute
